import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type UpdateDormakabaUserRequest = {
  email: string
  commonAreas: { commonAreaID: string }[]
}

const updateDormakabaUser = async (data: UpdateDormakabaUserRequest) => {
  const response = await authAPI.patch('/dormakaba/user', data)
  return response.data
}

export const useUpdateDormakabaUser = () =>
  useMutation({
    mutationFn: updateDormakabaUser,
  })
